
<div class="row content">

    <!-- File-info-foto -->
    <div class="row">
        <div class="col-12">
            <div class="img">
                <img src="https://roscontrol.com/wp-content/uploads/2021/09/e7b17f6a38a36f3af2d7.jpg">
            </div>
        </div>
    </div>

    <!-- File-info-link -->

    <div class="col-12 btn-position ">
            <!-- File-edit -->
            <button type="button" class="btn btn-light" (click)="fileEdit()" ngbTooltip="Редактиравать">
                <i class="bi bi-pencil-square btn-link-info"></i>
            </button>

            <!-- Link-file -->
            <button type="button" class="btn btn-light" (click)="fileLink()" ngbTooltip="Связать">
                <i class="bi bi-link-45deg btn-link-info"></i>
            </button>

            <!-- Download-file -->
            <button type="button" class="btn btn-light" (click)="fileDownload()" ngbTooltip="Загрузить">
                <i class="bi bi-download btn-link-info"></i>
            </button>
    </div>

    <!-- File-info-text -->
    <div class="card-info-text">
        <div class="row">
            <div class="col-12">
                <div class="product-info-titel">Упаковка 1</div>
            </div>
    </div>

        <div class="row">
        <div class="col-6">
            <div class="notification-info-title">Дата создания:</div>
        </div>
        <div class="col-6">
            <div class="org-info-value"></div>
        </div>
        </div>

        <div class="row">
        <div class="col-6">
            <div class="notification-info-title">Создал:</div>
        </div>
        <div class="col-6">
            <div class="org-info-value"></div>
        </div>
        </div>

        <div class="row">
        <div class="col-6">
            <div class="notification-info-title">Дата изменения:</div>
        </div>
        <div class="col-6">
            <div class="org-info-value">02.20</div>
        </div>
        </div>

        <div class="row">
        <div class="col-6">
            <div class="notification-info-title">Редоктировал:</div>
        </div>
        <div class="col-6">
            <div class="org-info-value"></div>
        </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="notification-info-title">Размер:</div>
            </div>
            <div class="col-6">
                <div class="org-info-value"></div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
             <div class="notification-info-title">Разрешение:</div>
            </div>
            <div class="col-6">
                <div class="org-info-value"></div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="notification-info-title">Товары (3):</div>
            </div>
            <div class="col-6">
                <div class="org-info-value"></div>
            </div>
        </div>

        <div class="row">
        <div class="col-6">
            <div class="notification-info-title">Деректория:</div>
        </div>
        <div class="col-6">
            <div class="org-info-value"></div>
        </div>
        </div>


        <div class="row">
            <div class="col-6">
                <div class="notification-info-title">Доступ:</div>
            </div>
            <div class="col-6">
                <div class="org-info-value"></div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="notification-info-title">Срок годности:</div>
            </div>
            <div class="col-6">
                <div class="org-info-value"></div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="notification-info-title">Правила привязки:</div>
            </div>
            <div class="col-6">
                <div class="org-info-value"></div>
            </div>
        </div>
    </div>
</div>
